exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_wks-ext.js
// module id = 171
// module chunks = 0